<template lang="pug">
  .form
    .form-group.m-bottom-1(v-if='isAdmin')
      label.text-normal.bold.m-bottom-05 {{ $t("registerUseModal.useForm.schoolLabel") }}
      k-select.m-right-auto.size-select(
        :placeholder='$t("registerUseModal.useForm.schoolPlaceholder")'
        name='schoolId' withBorder
        keyName='value'
        :options='schoolsOptions'
        @selectOption='updateSelect'
      )
    .form-group.m-bottom-1
      label.text-normal.bold.m-bottom-05 {{ $t("registerUseModal.useForm.courseLabel") }}
      tag-input(
        :disabled='(isAdmin && !schoolId) || loadingCourses'
        :placeholder='$t("registerUseModal.useForm.coursePlaceholder")'
        :value='courses'
        :options='coursesOptions'
        keyName='id'
        labelName='label'
        name='courses'
        @change='updateCourses'
      )
    .form-group.m-bottom-1
      label.text-normal.bold {{ $t("registerUseModal.useForm.dateLabel") }}
      k-datepicker.m-right-auto.size-select(
        :placeholder='$t("registerUseModal.useForm.datePlaceholder")'
        name='date' type='month' format='MMMM yyyy'
        @change='updateDate'
      )
    .form-group
      label.text-normal.bold {{ $t("registerUseModal.useForm.experienceLabel") }}
      textarea.input-base.input-border.textarea.text-normal(
        v-model='experience'
        :placeholder='$t("registerUseModal.useForm.experiencePlaceholder")'
      )
    .row.m-top-3
      button.secondary-button(@click='$emit("prev")')
        | {{ $t("registerUseModal.prev") }}
      button.primary-button.m-left-auto(@click='submit' :disabled='disabledSubmit')
        | {{ $t("registerUseModal.submit") }}
</template>

<script>
import KDatepicker from '@/components/KDatepicker'
import KSelect from '@/components/KSelect'
import TagInput from '@/components/Inputs/TagInput'
import userRole from '../../mixins/userRole'
import { mapActions, mapState } from 'vuex'
import { i18n } from '../../main'

export default {
  mixins: [userRole],
  components: { KSelect, KDatepicker, TagInput },
  data() {
    return {
      loadingCourses: false,
      courses: [],
      date: null,
      schoolId: null,
      experience: null
    }
  },
  created() {
    if (!this.isAdmin) {
      this.schoolId = this.userInfo.schoolId
      this.loadCourses()
    }
  },
  computed: {
    ...mapState({
      academicCourses: state => state.dashboard.academicCourses,
      schools: state => state.userInfo.schoolsWithCourses,
      userInfo: state => state.userInfo.userInfo
    }),
    schoolsOptions() {
      return this.schools.map(school => ({ value: school.id, label: school.name }))
    },
    coursesOptions() {
      return this.academicCourses.map(({ academicGrade, id }) => ({
        id: id,
        label: i18n.t(`academicGrades.${academicGrade.educationalType}.${academicGrade.translationId}`)
      }))
    },
    disabledSubmit() {
      return !this.courses.length || !this.date || (this.isAdmin && !this.schoolId)
    }
  },
  methods: {
    ...mapActions([
      'hydrateAcademicCourses'
    ]),
    async loadCourses() {
      this.loadingCourses = true
      await this.hydrateAcademicCourses({ schoolId: this.schoolId, isAdmin: this.isAdmin })
      this.loadingCourses = false
    },
    async updateSelect(name, value) {
      this[name] = value
      if (name === 'schoolId') await this.loadCourses()
    },
    updateCourses(value) {
      this.courses = value
    },
    updateDate(date) {
      this.date = date
    },
    async submit() {
      this.$emit('submit', {
        note: this.experience,
        useDate: this.date,
        schoolId: this.schoolId,
        academicCourseIds: this.courses
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.list{
  height: 300px;
}
.textarea{
  padding: 10px;
  height: 120px;
  resize: none;
}
</style>
